// eslint-disable-next-line import/prefer-default-export
export function setBodyScrollOverflow(hidden) {
  if (hidden) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}
